/* eslint-disable no-irregular-whitespace */
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { css } from "@styled-system/css";
import React from "react";

import { Box, Header, Text } from "~/components/blocks";

const Section = styled("section")(({ theme }) =>
  css({
    marginTop: theme.space.xl,
    fontSize: theme.fontSizes.s,
    "& > p + ul": {
      marginTop: theme.space.m,
    },
    "& > ul li + li": {
      marginTop: theme.space.s,
    },
  }),
);

export const PrivacyPolicy = () => {
  const theme = useTheme();

  return (
    <Box padding={theme.space.m}>
      <Header as="h2">
        処方箋情報事前送信サービスにおける個人情報の取扱いについて
      </Header>

      <Section>
        <Header as="h3">1. 目的</Header>
        <p>
          株式会社メドレー（以下、「当社」といいます。）は、当社が調剤薬局を利用する患者としてのユーザーに対して提供する処方箋情報事前送信サービス（以下、「本サービス」といいます。）を通じて取得される個人情報の取扱いを定めることを目的として、本個人情報取扱規程（以下「プライバシーポリシー」といいます）を定めます。
        </p>
      </Section>

      <Section>
        <Header as="h3">2. 定義</Header>
        <ul>
          <li>
            (1)
            「個人情報」とは、個人に関する情報であり、本サービスを利用する一切の個人（以下、「利用者」といい、個人顧客、取引先、従業員など一切の個人が該当します。）に関する情報であって、住所、氏名、電話番号、電子メールアドレスなどの文字、映像、音声などによって当該個人を識別できる情報をいいます。また、その情報のみでは識別できない場合でも、他の情報と容易に照合することができ、結果的に個人を識別できるものも個人情報に含まれます。なお、死者に関する情報であって、その他の上記個人情報の定義に該当するもの（「準個人情報」）も個人情報に含まれます。
          </li>
          <li>
            (2)
            「登録調剤薬局」とは、本サービスを利用・導入して、利用者に調剤業務、服薬指導、処方薬等の提供をする調剤薬局その他の法人であり、調剤・服薬指導等の業務に従事する者をいいます。
          </li>
          <li>
            (3)
            「提携事業者」とは、登録調剤薬局がその事業の運営のために登録施設のサービス利用者の個人情報の保管、管理等の委託等の事業上の提携関係にある事業者をいいます。
          </li>
        </ul>
      </Section>

      <Section>
        <Header as="h3">3. 個人情報管理責任者および連絡先について</Header>
        <p>
          個人情報管理責任者およびその連絡先は以下の通りです。
          <br />
          株式会社メドレー個人情報管理責任者
          <br />
          TEL : 03-4520-9820
          <br />
          E-mail：privacy@medley.jp
          <br />
          ※受付時間は平日午前9時から午後6時までとなっております。
          <br />
          ※直接ご来社いただいてのお問い合わせはお受けいたしかねます。
        </p>
      </Section>

      <Section>
        <Header as="h3">4. 個人情報の取得、取得する情報</Header>
        <ul>
          <li>
            1. 当社は、以下の場合に個人情報を取得します。
            <ul>
              <li>
                (1) 端末操作を通じて利用者が氏名、連絡先情報等を入力する場合
              </li>
              <li>
                (2) 利用者による本サービスの利用に伴って自動的に送信される場合
              </li>
              <li>
                (3)
                登録調剤薬局による本サービスの利用に伴って、登録調剤薬局が本サービス上で情報送信する場合
              </li>
            </ul>
          </li>
          <li>
            2.
            当社が本サービスの提供に際して利用者から取得する個人情報は、以下の通りです。
            <ul>
              <li>(1) 氏名および電話番号</li>
              <li>
                (2)
                利用する調剤薬局名、受付日時、処方箋画像（薬剤名、調剤日、剤形、用量、用法を含む。）、質問表回答情報その他利用者が提供する健康情報
              </li>
              <li>
                (3) その他利用者が本サービスの利用に際して入力、提供する情報
              </li>
            </ul>
          </li>
        </ul>
      </Section>

      <Section>
        <Header as="h3">5. 個人情報の利用目的</Header>
        <p>
          当社は、以下の目的のために個人情報を利用します。当社がやむをえず下記の目的以外の理由で利用を行う場合は、利用者にその旨を通知し、その同意を得た上で利用します。
        </p>
        <ul>
          <li>(1) 当社が利用者の個人確認を行い、本サービスを提供するため</li>
          <li>
            (2)
            本サービスの提供のために必要な限度で、利用者が処方箋情報を事前送信した調剤薬局に対して利用者の個人情報を提供するため
          </li>
          <li>
            (3)
            利用者の服薬指導の完了状況等の確認をし、必要なフォローアップ、リマインダ等の連絡をするため
          </li>
          <li>
            (4)
            本サービスに関連して当社が提供する医療関連サービスの紹介等を目的としたプロモーションを利用者に送信するため
          </li>
          <li>
            (5)
            個人を特定できない範囲で本サービスに関する統計情報の作成および利用を行うため
          </li>
          <li>
            (6)
            本サービスに関する利用者からのお問合せ、ご相談および苦情への対応ならびに紛争の解決のために必要な業務を行うため
          </li>
          <li>(7) 本サービスの改善、不具合対応、および開発を行うため</li>
          <li>
            (8)
            本サービスの利用規約に違反した利用者による本サービスの利用を停止等するため
          </li>
          <li>(9) その他上記目的に関連・付随する目的の達成に必要な場合</li>
        </ul>
      </Section>

      <Section>
        <Header as="h3">6. 個人情報の第三者提供について</Header>
        <ul>
          <li>
            1.
            当社は、原則として、利用者の同意を得ずに、利用目的に定める以外で利用者の個人情報を第三者に提供いたしません。
            <br />
            なお、利用者は、自らが本サービスを通じて登録調剤薬局に対し、医薬品の調剤行為が完了したときに、完了の通知を受け取ることを依頼（処方箋情報事前送信機能の利用）した場合に、本サービスの利用にあたり利用者が入力した情報が、当該登録調剤薬局に共有されることについて同意するものとします。
            <br />
            また、以下に掲げる場合は、利用者の同意なく個人情報を第三者に提供することがあります。
          </li>
          <li>
            <ul>
              <li>(1) 法令に基づく場合</li>
              <li>
                (2)
                人の生命、身体又は財産の保護のために必要がある場合であって、利用者の同意を得ることが困難である場合
              </li>
              <li>
                (3)
                公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、利用者の同意を得ることが困難である場合
              </li>
              <li>
                (4)
                国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、利用者の同意を得ることによってその事務の遂行に支障を及ぼすおそれがあると当社が判断した場合
              </li>
              <li>
                (5)
                裁判所、検察庁、警察、弁護士会、消費者センターまたはこれらに準じる機関から、個人情報についての開示を求められた場合
              </li>
              <li>
                (6) 利用者から明示的に第三者への開示または提供を求められた場合
              </li>
              <li>
                (7)
                利用目的の達成に必要な範囲内において個人情報取扱い業務の一部または全部を委託する場合
              </li>
              <li>
                (8) 合併その他の事由による事業の承継に伴って提供される場合
              </li>
              <li>
                (9)
                当社の正当な業務の範囲内であって、利用者の利益が侵害されるおそれのない提供を行う場合
              </li>
            </ul>
          </li>
          <li>
            2.
            本サービスを利用して登録調剤薬局に対して提供された個人情報は、登録調剤薬局の判断及び指示に基づき、本サービスを経由して登録調剤薬局のために個人情報を保管・管理する提携事業者に提供される場合があります。この登録調剤薬局による本サービスを経由した提携事業者への個人情報の提供は、利用者の個別の同意がない限りは、登録調剤薬局が利用者に対して利用者が希望したサービスを提供するための利用目的に限られます。
            <br />
            なお、利用者が個別に同意した場合において、本サービスを経由して利用者が登録調剤薬局に提供した情報が、登録調剤薬局から提携事業者に対して第三者提供される場合、かかる第三者提供については当社の管理外であり、当社はかかる提供に関する一切の責任を負わないものとします。
          </li>
          <li>
            3.
            当社は、本サービスの提供・品質向上や、新規サービス開発のために必要な場合、または調査・研究・分析のために登録調剤薬局やその他の研究機関に提供する必要がある場合には、氏名・電話番号など直接特定の個人を識別できる情報を排除した上で、必要な範囲で第三者に統計情報を提供します。
          </li>
        </ul>
      </Section>

      <Section>
        <Header as="h3">7. 免責</Header>
        <p>
          以下の場合、第三者による個人情報の取得に関して当社は何らの責任を負いません。
        </p>
        <ul>
          <li>(1) 利用者自らが第三者に個人情報を明らかにする場合</li>
          <li>
            (2)
            利用者または利用者以外の者が本サービスにおいて入力した情報により、期せずして個人の識別が可能な状態となってしまった場合
          </li>
          <li>
            (3)
            本サービス外の外部サイトにおいて、利用者が個人情報を提供し、それが第三者により取得・利用された場合
          </li>
        </ul>
      </Section>

      <Section>
        <Header as="h3">
          8. 顧客企業等の第三者における個人情報管理について
        </Header>
        <p>
          利用者の同意に基づき、登録調剤薬局その他顧客企業等の第三者に提供された個人情報は、各提供先の第三者の責任により管理されます。
          <br />
          なお、当社では利用規約、個別契約等により、登録調剤薬局に対して利用者の個人情報を適切に管理することを義務付ける契約を結んでいます。
        </p>
      </Section>

      <Section>
        <Header as="h3">9. 個人情報の委託について</Header>
        <p>
          当社は利用目的の達成に必要な範囲内において個人情報の取扱いの全部または一部を委託する場合があります。なお、当社が個人情報の取扱いを委託する場合は、適切な委託先を選定し、個人情報が安全に管理されるよう適切に監督するものとします。
        </p>
      </Section>

      <Section>
        <Header as="h3">10. 個人情報の正確性について</Header>
        <p>
          当社は、ご提供いただいた個人情報を正確にデータ処理するように努めます。ただし、ご提供いただいた個人情報の内容が正確かつ最新であることについては、利用者が責任を負うものとします。
        </p>
      </Section>

      <Section>
        <Header as="h3">11. 個人情報の開示等</Header>
        <ul>
          <li>
            1.
            利用者またはその適法な代理人に限り、当社に対して利用目的の通知、個人情報の開示、追加、訂正、削除、利用停止、および第三者への提供の停止（以下、「開示等」といいます。）を求めることができるものとし、当社は個人情報保護法の定めに従ってこれに遅滞なく対応します。利用者は、かかる個人情報の削除や利用停止等により、本サービスを受けることができなくなる場合があります。また、当社が開示等に対応することによって、以下のいずれかに該当する場合は、開示等に対応できない場合がございます。
            <ul>
              <li>
                (1)
                利用者または第三者の生命、身体、財産その他の権利利益を害するおそれがある場合
              </li>
              <li>
                (2) 当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合
              </li>
              <li>(3) 法令に違反することとなる場合</li>
            </ul>
          </li>
          <li>
            2.
            個人情報の利用目的の通知、および個人情報の開示等の請求については、当社は１回ごとに当社所定の手数料を徴収します。利用者は、これを行うときは
            <a
              target="_blank"
              rel="noreferrer noopener"
              href="https://www.medley.jp/medley-privacy-form.pdf"
            >
              当社が指定する必要書類
            </a>
            に当該所定手数料分の郵便定額小為替を同封して郵送するものとします。
          </li>
        </ul>
      </Section>

      <Section>
        <Header as="h3">12. 統計処理されたデータの利用について</Header>
        <p>
          当社は、提供を受けた個人情報をもとに、個人を特定できないよう加工した統計データを作成することがあります。個人を特定できない統計データについては、当社は何ら制限なく利用することができるものとします。
        </p>
      </Section>

      <Section>
        <Header as="h3">13. プライバシーポリシーの変更</Header>
        <p>
          当社は法令等で定めがある場合を除き、プライバシーポリシーを随時変更することができるものとします。変更を行う場合には、本サービスを提供するウェブサイト上にて変更後のプライバシーポリシーを掲載するものとします。
        </p>
      </Section>

      <Box textAlign="right" marginTop={theme.space.l}>
        <Text as="p" size="s">
          2021年10月19日制定
          <br />
          株式会社メドレー
          <br />
          代表取締役社長　瀧口　浩平
        </Text>
      </Box>
    </Box>
  );
};
